<p class="modal-title">Affiliate Tracker: {{ affiliate().name }}</p>
<div class="body flex flex-col">
  <div class="filters">
    <div class="filters__row">
      <app-search-input
        class="filters__input"
        placeholder="SteamID..."
        [(query)]="userIdFilter"
        (onEnter)="applyFilters()"
        (onClear)="applyFilters()"
      />
      <app-search-input
        class="filters__input"
        placeholder="Name..."
        [(query)]="nameFilter"
        (onEnter)="applyFilters()"
        (onClear)="applyFilters()"
      />
      <app-search-input
        class="filters__input"
        placeholder="Source (game)..."
        [(query)]="sourceFilter"
        (onEnter)="applyFilters()"
        (onClear)="applyFilters()"
      />
      <app-search-input
        class="filters__input"
        placeholder="Source ID..."
        [(query)]="sourceIdFilter"
        (onEnter)="applyFilters()"
        (onClear)="applyFilters()"
      />
    </div>
    <div class="filters__row selects">
      <app-select
        [title]="'Type'"
        [selected]="type()"
        [options]="typeOptions"
      />
      <app-select
        [title]="'Order by'"
        [selected]="order()"
        [options]="orderOptions"
      />
      <app-select
        [title]="'Order'"
        [selected]="orderField()"
        [options]="orderFieldOptions"
      />
      <button
        class="button button--style-primary h-32 padding-x-12 rounded-4"
        (click)="handleResetFilters()"
      >
        Reset filters
      </button>
      <button
        class="button button--style-primary h-32 padding-x-12 rounded-4"
        (click)="applyFilters()"
      >
        Apply
      </button>
    </div>
  </div>

  <div class="events">
    @let isEmpty = eventsResource.hasValue() && eventsResource.value().length
    === 0;

    @if (eventsResource.error() || isEmpty) {
    <div
      style="text-align: center"
      class="flex flex-col gap-4 items-center justify-center w-full h-full"
    >
      {{ eventsResource.error() ? eventsResource.error() : 'No earnings found by your filters' }}
      <div class="flex gap-4 items-center justify-center w-full flex-wrap">
        <button
          class="button button--style-primary h-32 padding-x-12 rounded-4"
          (click)="eventsResource.reload()"
        >
          Reload
        </button>
        <button
          class="button button--style-primary h-32 padding-x-12 rounded-4"
          (click)="handleResetFilters()"
        >
          Reset filters
        </button>
      </div>
    </div>
    } @else if (eventsResource.isLoading()) {
    <app-loading-icon
      class="absolute-center"
      [color]="'var(--yellow)'"
      [size]="'48px'"
      animate.enter="animate-fade-in"
    />
    } @else if (eventsResource.hasValue() && eventsResource.value().length > 0)
    {
    <app-table
      animate.enter="animate-fade-in"
      [data]="eventsResource.value()"
      [columns]="columns"
    />
    }
  </div>

  <app-table-pagination
    animate.enter="animate-fade-in"
    [currentPage]="pagination().pageIndex + 1"
    [disabledPreviousPage]="
      eventsResource.isLoading() ||
      !!eventsResource.error() ||
      pagination().pageIndex === 0
    "
    [disabledNextPage]="
      eventsResource.isLoading() ||
      !!eventsResource.error() ||
      pagination().pageIndex + 1 >= totalPages()
    "
    [showLastPage]="false"
    (handlePreviousPage)="handlePaginationChange('prev')"
    (handleNextPage)="handlePaginationChange('next')"
    (handleFirstPage)="handlePaginationChange('reset')"
  ></app-table-pagination>
</div>
